module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.vw <= 1024),
      expression: "vw <=1024"
    }],
    staticClass: "sl"
  }, [_c('div', {
    staticClass: "padding"
  }, [_c('div', {
    staticClass: "owl-carousel"
  }, [_vm._l((_vm.items), function(item) {
    return [_c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "hdr"
    }, [_vm._v(_vm._s(item.header))]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.text))])])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cols s_24"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "pointer",
    style: (("width: " + _vm.pointerWidth + "px; transform: translateX(" + _vm.left + "px)"))
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.vw > 1024),
      expression: "vw > 1024"
    }],
    staticClass: "sc"
  }, [_c('ul', {
    staticClass: "grid l_2"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', [_c('div', {
      staticClass: "hdr"
    }, [_vm._v(_vm._s(item.header))]), _vm._v(" "), _c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.text))])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d8b5001"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/sliders/bx24-complex.vue
// module id = 401
// module chunks = 14